/* AI Agent làm theo chỉ thị của anh Hoá — 2026-10-18 09:46 VN — WEB-20261018-suzitee-cart-preview-pill
   Đã làm: (1) ánh sáng lướt 1 LẦN trên nút "Preview design" mỗi khi mở giỏ (drawer: sự kiện szmc:open của assets/sz_minicart.js;
   trang /cart: 1 lần sau khi tải) — không lặp, bỏ qua khi prefers-reduced-motion; (2) Enter/Space trên nút (role=button, <a> không href) = bấm.
   Không MutationObserver trên body: chỉ quan sát childList TRỰC TIẾP của .szmc-dw trong 3s sau khi mở (drawer vẽ lại ruột bằng innerHTML),
   callback chỉ thêm class lên nút con → không tự kích. Lỗi gì cũng nuốt (try/catch) để không chặn script khác. */
(function () {
  try {
    var RM = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var SEL = 'a.sz-pvpill';
    function shineIn(root) {
      if (!root || (RM && RM.matches)) return;
      var els = root.querySelectorAll(SEL + ':not([data-sz-shone])');
      for (var i = 0; i < els.length; i++) (function (el) {
        el.setAttribute('data-sz-shone', '1');
        el.classList.add('is-shine');
        setTimeout(function () { el.classList.remove('is-shine'); }, 1400);
      })(els[i]);
    }
    var mo = null, moT = 0;
    document.addEventListener('szmc:open', function () {
      try {
        var dw = document.querySelector('.szmc-dw'); if (!dw) return;
        var old = dw.querySelectorAll(SEL + '[data-sz-shone]');
        for (var i = 0; i < old.length; i++) { old[i].removeAttribute('data-sz-shone'); old[i].classList.remove('is-shine'); }
        setTimeout(function () { shineIn(dw); }, 380);
        if (window.MutationObserver) {
          if (mo) mo.disconnect(); clearTimeout(moT);
          mo = new MutationObserver(function () { setTimeout(function () { shineIn(dw); }, 120); });
          mo.observe(dw, { childList: true });
          moT = setTimeout(function () { if (mo) { mo.disconnect(); mo = null; } }, 3000);
        }
      } catch (e) {}
    });
    function pageInit() {
      try { var f = document.getElementById('cart_form'); if (f && !f.closest('.szmc-dw')) setTimeout(function () { shineIn(f); }, 700); } catch (e) {}
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pageInit); else pageInit();
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
      var a = e.target && e.target.closest && e.target.closest(SEL);
      if (!a || a !== e.target) return;
      e.preventDefault(); a.click();
    });
  } catch (e) {}
})();
